// extracted by mini-css-extract-plugin
export default {"stat_container":"StatInfo_stat_container__YnkgP"};